import { NetworkActionPrefix, ActionType, RequestStatus, WatchType } from '../utils/constants';
import { watchReportID, queryToEntity } from '../api/utils';
import defaults from '../api/defaults';
import { deepAssign } from '../utils';
import { LOCATION_CHANGE } from 'react-router-redux';
import { NewsEntryFilter } from 'for-straction-service-api';

import {
    pipeReducers, combineReducers,
    networkObjectLoadReducer, networkEntityLoadReducer, networkEntityAddReducer, networkEntityEditReducer, networkEntityDeleteReducer,
    assignmentReducer, networkActionReducer
} from '../utils/reducerFactory';

function watchIndex(list, watchType, watchID) {
    if (watchType !== undefined && watchID !== undefined) {
        return list.getIndexByID(watchReportID(watchType, watchID)) !== -1 ? list.getIndexByID(watchReportID(watchType, watchID)) : list.length;
    }
    return undefined;
}

const watches = pipeReducers(
    combineReducers({
        list: pipeReducers(
            networkObjectLoadReducer(NetworkActionPrefix.LOAD_MARKET_WATCH_LIST_PREFIX, defaults.NetworkArrayOf(defaults.ContentWatchSettings)),
            combineReducers({
                Data: combineReducers({
                    '@watchIndex': pipeReducers(
                        networkEntityLoadReducer(NetworkActionPrefix.LOAD_MARKET_WATCH_PREFIX, defaults.ContentWatchSettings),
                        networkEntityAddReducer(NetworkActionPrefix.ADD_MARKET_WATCH_PREFIX, defaults.ContentWatchSettings, (state, action) => action.watch),
                        function (state, action) {
                            state = state || defaults.ContentWatchSettings;

                            switch (action.type) {
                                case ActionType.LOAD_MARKET_WATCH_PENDING:
                                    return deepAssign(state, {
                                        ID: watchReportID(action.watchType, action.watchID),
                                        WatchID: action.watchID,
                                        Type: action.watchType
                                    });
                                case ActionType.ADD_MARKET_WATCH_SUCCESS:
                                    return deepAssign(state, { WatchID: +action.response.split('_')[1] });
                                default:
                                    return state;
                            }
                        },
                        networkEntityEditReducer(NetworkActionPrefix.EDIT_MARKET_WATCH_PREFIX, defaults.ContentWatchSettings, (state, action) => action.watch),
                        networkEntityDeleteReducer(NetworkActionPrefix.DELETE_MARKET_WATCH_PREFIX)
                    )
                }, {
                        watchIndex: (state, action) =>
                            action.type !== ActionType.EDIT_MARKET_WATCH && action.type !== ActionType.SAVE_MARKET_WATCH ?
                                watchIndex(state, action.watchType, action.watchID) :
                                undefined
                    })
            })),
        editable: pipeReducers(
            (state) => state || null,
            combineReducers({
                Type: assignmentReducer(ActionType.SET_MARKET_WATCH_TYPE, null, 'watchType'),
                Name: assignmentReducer(ActionType.SET_MARKET_WATCH_NAME, '', 'name'),
                TargetURI: assignmentReducer(ActionType.SET_MARKET_WATCH_URL, '', 'URL'),
                Selector: assignmentReducer(ActionType.SET_MARKET_WATCH_SELECTOR, '', 'selector'),
                ModeratorID: assignmentReducer(ActionType.SET_MARKET_WATCH_MODERATOR, null, 'moderatorID'),
                PESTELAreaID: assignmentReducer(ActionType.SET_MARKET_WATCH_PESTEL_AREA, null, 'pestelAreaID'),
                SWOTTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_WATCH_SWOT_TOPIC:
                            return action.swotTopicID;
                        default:
                            return state;
                    }
                },
                PersonalTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_WATCH_PERSONAL_TOPIC:
                            return action.personalTopicID;
                        default:
                            return state;
                    }
                },
                TrendTopicID: function (state, action) {
                    switch (action.type) {
                        case ActionType.SET_MARKET_WATCH_TREND_TOPIC:
                            return action.trendTopicID;
                        default:
                            return state;
                    }
                },
                StakeholderID: assignmentReducer(ActionType.SET_MARKET_WATCH_STAKEHOLDER_ID, null, 'stakeholderID'),
                CompanyLegalEntityID: assignmentReducer(ActionType.SET_MARKET_WATCH_COMPANY_LEGAL_ENTITY_ID, null, 'companyLegalEntityID'),
                CompanyFunctionID: assignmentReducer(ActionType.SET_MARKET_WATCH_COMPANY_FUNCTION_ID, null, 'companyFunctionID'),
                Custom: combineReducers({
                    page: networkActionReducer(NetworkActionPrefix.LOAD_MARKET_WATCH_URL_PREFIX, { Custom: { status: RequestStatus.UNSYNCED } }),
                    suggestions: assignmentReducer(ActionType.SET_MARKET_WATCH_SUGGESTIONS, [], 'suggestions'),
                    highlightSelector: assignmentReducer(ActionType.SET_MARKET_WATCH_HIGHLIGHT_SELECTOR, '', 'selector'),
                    extend: assignmentReducer(ActionType.SET_MARKET_WATCH_EXTEND, '', 'extend'),
                })
            })
        ),
        currentlyViewedWatchId: assignmentReducer(ActionType.SHOW_MARKET_WATCH_DETAILS, null, 'ID'),
        detailModalContent: assignmentReducer(ActionType.MARKET_WATCH_CHANGE_DETAIL_MODAL_CONTENT, null, 'detailModalContent'),
        sourcesFilter: (state, action) =>
            action.type === LOCATION_CHANGE && action.payload.pathname === '/market_radar/sources/watches/new' ?
                deepAssign(state, queryToEntity(action.payload.query, NewsEntryFilter)) :
                state || defaults.NewsEntryFilter
    }),
    function (state, action) {
        state = state || { list: defaults.NetworkArray, editable: null, currentlyViewedWatchId: null };

        switch (action.type) {
            case ActionType.EDIT_MARKET_WATCH:
                return deepAssign(state, {
                    editable: action.watchID ?
                        state.list.Data.getByID(watchReportID(action.watchType, action.watchID)) || deepAssign(defaults.ContentWatchSettings, {
                            ID: watchReportID(action.watchType, action.watchID),
                            Type: action.watchType,
                            WatchID: action.watchID,
                            Custom: {
                                status: RequestStatus.SUCCEEDED
                            }
                        }) :
                        null
                });

            case ActionType.SAVE_MARKET_WATCH:
                return deepAssign(state, {
                    list: {
                        Data: {
                            [watchIndex(state.list.Data, action.watchType, action.watchID)]: deepAssign(state.editable, {
                                ID: watchReportID(state.editable.Type, state.editable.WatchID)
                            })
                        }
                    },
                    editable: {
                        ID: watchReportID(state.editable.Type, state.editable.WatchID)
                    }
                });

            case ActionType.ADD_MARKET_WATCH_PENDING:
            case ActionType.ADD_MARKET_WATCH_SUCCESS:
            case ActionType.ADD_MARKET_WATCH_FAIL:
                if (state.editable && state.editable.ID === watchReportID(action.watchType, action.watchID)) {
                    return deepAssign(state, {
                        editable: state.list.Data.getByID(action.response || watchReportID(action.watchType, action.watchID))
                    });
                }
                return state;

            case ActionType.LOAD_MARKET_WATCH_PENDING:
            case ActionType.LOAD_MARKET_WATCH_SUCCESS:
            case ActionType.LOAD_MARKET_WATCH_FAIL:
            case ActionType.EDIT_MARKET_WATCH_PENDING:
            case ActionType.EDIT_MARKET_WATCH_SUCCESS:
            case ActionType.EDIT_MARKET_WATCH_FAIL:
                if (state.editable && state.editable.ID === watchReportID(action.watchType, action.watchID)) {
                    return deepAssign(state, {
                        editable: deepAssign(state.list.Data.getByID(watchReportID(action.watchType, action.watchID)), {
                            Custom: {
                                isSaving: action.type === ActionType.EDIT_MARKET_WATCH_PENDING
                            }
                        })
                    });
                }
                return state;
            case ActionType.CLOSE_MARKET_WATCH_DETAILS:
                return Object.assign({}, state, {
                    currentlyViewedWatchId: null
                });

            default:
                return state;
        }
    },
    function (state, action) {
        switch (action.type) {
            case ActionType.DELETE_STAKEHOLDER_SUCCESS:
            case ActionType.DELETE_SWOT_SESSION_SUCCESS:
            case ActionType.DELETE_SWOT_TOPIC_SUCCESS:
            case ActionType.DELETE_TREND_TOPIC_SUCCESS:
                // TODO make it more targeted, not all parts require update
                return watches(undefined, { type: '@@redux/INIT' });
            default:
                return state;
        }
    }
);

export default watches;